var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "button",
    {
      staticClass: "btn\nbtn--social\nbtn--facebook",
      attrs: { type: "submit" },
      on: { click: _vm.facebookLogin }
    },
    [
      _c("svgicon", {
        attrs: { name: "facebook", original: true, width: "24", height: "24" }
      }),
      _vm._v("\n\n    " + _vm._s(_vm.$t("Log in with")) + " Facebook\n")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-3065e50e", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3065e50e","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./src/components/component/buttons/facebook/facebook.html
// module id = null
// module chunks = 